<template>
    <div class="strategy-square">
        <div class="strategy-square-head">
            <div class="head-search left">
                <span>交易策略</span>
                <label>
                    <input type="text" v-model="tradeStraKeyWord" placeholder="搜索关键词" @keyup.enter="updateSearch">
                    <span @click="updateSearch"></span>
                </label>
            </div>
            <div class="head-sort right">
                <label>
                    <span>排序 : </span>
                    <select v-model="sortSelect" @change="updateSort">
                        <option v-for="(item, index) in sortSelectList" :key="index" :value="item.value">
                            {{item.text}}
                        </option>
                    </select>
                </label>
            </div>
        </div>

        <div class="strategy-square-body">
            <vue-loading v-show="loading"></vue-loading>
            <p v-if="!loading && strategyDataList.length === 0">暂无查询列表数据</p>
            <div class="body-data-list" v-if="strategyDataList.length !== 0">
                <item-row v-for="(item, i) in strategyDataList"
                :key="i"
                :index-serial="i"
                :page="currentPage"
                :strategy-id="item.property.id"
                :buy-position="parseInt(item.property.buyPosition)"
                :strategy-name="item.property.name"
                :strategy-logic="item.property.logic"
                :strategy-ctime="item.property.ctime"
                :strategy-annual-yield="item.property.annualYield"
                :strategy-win-rate="item.property.winRate"
                :strategy-tags="item.property.tags"
                :strategy-user="item.author.userName"
                :strategy-avatar="item.author.avatar"
                :strategy-user-id="item.author.userId"
                :strategy-collect-num="item.interaction.collectNum"
                :strategy-comment-num="item.interaction.commentNum"
                :strategy-is-collected="item.interaction.isCollected"
                :reset-stock="resetStock"
                :strategy-type="item.property.type">
                </item-row>
            </div>
        </div>
        <div class="pagination-heart">
            <vue-pagination
                class="square-page"
                :page-size="pageSize"
                :total="total"
                @current-change="goPage">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import itemRow from './item-row'
    export default {
        name: 'strategysquare',
        components: {
            itemRow
        },
        data () {
            return {
                pageSize: 10,
                currentPage: 1,
                total: 0,
                tradeStraKeyWord: '',
                sortSelect: '',
                sortSelectList: [
                    {text: '热度', value: 'hot'},
                    {text: '年化收益', value: 'profit'},
                    {text: '成功率', value: 'winRate'},
                    {text: '最新', value: 'createTime'},
                    {text: '本月收益', value: 'gain'}
                ],
                strategyDataList: [],
                loading: false,
                resetStock: false
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.updateList()
            })
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.strategySquare
            },
            totalPoint () {
                return this.$buriedPoint.totalPlatformAccess
            }
        },
        methods: {
            updateSort () {
                window.TA.log(this.buriedPoint.sort[this.sortSelect])
                this.resetStock = !this.resetStock
                this.updateList()
            },
            updateSearch () {
                window.TA.log(this.buriedPoint.search)
                this.updateList()
            },
            updateList () {
                this.loading = true
                var self = this
                axios.get('/strategysquare/list?order=desc', {params: {
                    page: this.currentPage,
                    pageNum: this.pageSize,
                    sortType: this.sortSelect,
                    keyword: this.tradeStraKeyWord
                }
                }).then((res) => {
                    self.loading = false
                    self.total = res.data.result.num
                    return res.data.result.list
                }).then((data) => {
                    self.strategyDataList = data
                }).catch(function (error) {
                    self.loading = false
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            goPage (page) {
                // window.TA.log(this.buriedPoint.goPage)
                this.currentPage = page
            }
            // __scrollBar__ () {
            //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
            //         window.TA.log(this.buriedPoint.scrollBar)
            //     }
            // }
        },
        created () {
            if (this.sortSelect === '') {
                this.sortSelect = this.sortSelectList[0].value
            }
        },
        beforeDestroy () {
            // window.removeEventListener('scroll', this.__scrollBar__)
        },
        mounted () {
            var self = this
            // window.addEventListener('scroll', self.__scrollBar__)
            window.TA.log({id: self.buriedPoint.pageAccess, _sid: '__ths_001'})
            // window.TA.log({id: self.totalPoint, _sid: '__ths_002'})
        },
        watch: {
            currentPage () {
                this.updateList()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategysquare/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategysquare/index.vue